<template>
  <div class="fav-main flex-col">
    <div class="top">
      <div class="flex-row header-ctrl">
        <i class="iconfont iconarrowleft-outline"
          @click="goback"
          style="font-size: 26px"></i>
      </div>
      <div class="header-info">
        {{ $t("myHistory") }}
      </div>
    </div>
    <div class="cont-center">
      <van-tabs ref="tabs"
        v-model="active"
        style="height: 100%"
        @click="tabClick">
        <!-- <van-tab title="关系" class="tab-org">
                    <relationship-list
                        :page-type="pageType"
                        :is-edit="isEdit"
                        ref="relation"
                    ></relationship-list>
                </van-tab> -->
        <van-tab title="机构联系人"
          title-style="flex:1.2"
          class="tab-org">
          <contractor-list :page-type="pageType"
            :is-edit="isEdit"
            ref="contractor"
            id='tab-contractor'></contractor-list>
        </van-tab>
        <van-tab title="公司联系人"
          title-style="flex:1.2"
          class="tab-org">
          <contractor-list-company :page-type="pageType"
            :is-edit="isEdit"
            ref="contractorListCompany"
            id='tab-company-contractor'></contractor-list-company>
        </van-tab>
        <van-tab title="机构"
          class="tab-org">
          <his-org-list :page-type="pageType"
            :is-edit="isEdit"
            ref="orgList"
            id='tab-org'></his-org-list>
        </van-tab>
        <van-tab title="公司"
          class="tab-org">
          <invested-list ref="invested"
            :page-type="pageType"
            :is-edit="isEdit"
            id='tab-company'></invested-list>
        </van-tab>

        <van-tab title="市场情报"
          class="tab-org">
          <news-list :news-type="newsTypeActive"
            :is-edit="isEdit"
            ref="marketNews"
            id='tab-news'></news-list>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import webService from "@network/webService";
import RelationshipList from "@components/content/relation/RelationshipList";
import HisOrgList from "./HisOrgList";
import InvestedList from "@components/content/invested/InvestedList";
import ContractorList from "@components/content/contractor/ContractorList";
import ContractorListCompany from "@components/content/contractor/ContractorHistory";
import NewsList from "../overview/NewsList";
import scollerLocation from '@/common/scollerLocation';
import common from "@common/common";
export default {
  mixins: [],
  data () {
    return {
      newsTypeActive: 3,
      active: 0,
      list: [],
      loading: false,
      finished: false,
      isEdit: false,
      pageType: common.searchTypeEnum.contractorHistory,
    };
  },
  components: {
    RelationshipList,
    HisOrgList,
    InvestedList,
    ContractorList,
    ContractorListCompany,
    NewsList
  },
  activated () {
    scollerLocation.recoverLocation('tab-contractor');
    scollerLocation.recoverLocation('tab-company-contractor');
    scollerLocation.recoverLocation('tab-org');
    scollerLocation.recoverLocation('tab-company');
    scollerLocation.recoverLocation('tab-news');
  },
  beforeRouteLeave (to, from, next) {
    var dataList = document.querySelector('#tab-contractor .cont-list');
    if (dataList) {
      scollerLocation.saveLocation('tab-contractor', dataList);
    }
    var datacompanyList = document.querySelector('#tab-company-contractor .cont-list');
    if (datacompanyList) {
      scollerLocation.saveLocation('tab-company-contractor', datacompanyList);
    }
    var orgList = document.querySelector('#tab-org .cont-list');
    if (orgList) {
      scollerLocation.saveLocation('tab-org', orgList);
    }
    var companyList = document.querySelector('#tab-company .cont-list');
    if (companyList) {
      scollerLocation.saveLocation('tab-company', companyList);
    }
    var newsList = document.querySelector('#tab-news .cont-list');
    if (newsList) {
      scollerLocation.saveLocation('tab-news', newsList);
    }
    next();
  },
  computed: {
    curComponent () {
      console.log(this.pageType)
      let component = null;
      if (this.pageType == common.searchTypeEnum.contractorCompanyHistory) {
        component = this.$refs.contractorCompany;
      } else if (this.pageType == common.searchTypeEnum.orgHistory) {
        component = this.$refs.orgList;
      } else if (this.pageType == common.searchTypeEnum.contractorHistory) {
        component = this.$refs.contractor;
      } else if (this.pageType == common.searchTypeEnum.investedHistory) {
        component = this.$refs.invested;
      } else if (this.pageType == common.searchTypeEnum.newsHistory) {
        component = this.$refs.marketNews;
      }
      return component;
    },
  },

  methods: {
    tabClick (name, title) {
      console.log(name)
      // this._active = name;
      if (name == 0) {
        this.pageType = common.searchTypeEnum.contractorHistory;
      } else if (name == 1) {
        this.pageType = common.searchTypeEnum.contractorCompanyHistory;
      } else if (name == 2) {
        this.pageType = common.searchTypeEnum.orgHistory;
      } else if (name == 3) {
        this.pageType = common.searchTypeEnum.investedHistory;
      } else if (name == 4) {
        this.pageType = common.searchTypeEnum.newsHistory;
      }
      sessionStorage.setItem("_activeHistory", name);
      sessionStorage.setItem("_pageTypeHistory", this.pageType);
    },
    deleteItem () {
      this.curComponent.deleteItem();
    },

    goback () {
      this.$router.back(-1);
    },
  },
  created () {
    this.active = parseInt(sessionStorage.getItem("_activeHistory"));
    this.tabClick(this.active);
    // this.pageType = parseInt(sessionStorage.getItem("_pageTypeHistory"));

    // this.active = parseInt(sessionStorage.getItem("_activeHistory"));

    // console.log("fav: created ", this.active, this.pageType);
  }
};
</script>

<style lang='scss' scoped>
@import "../../styles/theme.scss";
.fav-main {
  height: 100%;
}
.top {
  height: 5.6rem;
  padding: 5px 10px 0 10px;
  .header-info {
    // font-weight: bolder;
    // font-size: 1.625rem;
    font-size: 25px;
    padding-top: 10px;
    color: #2d2d2d;
  }
  .header-ctrl {
    height: 36px;
    align-items: center;
    .icon-back {
      font-size: $size-24;
    }
    .header-right {
      flex: 1;
      text-align: right;
      padding-right: 10px;
      .btn-cancel {
        color: rgb(152, 42, 33);
      }
    }
  }
}
.cont-center {
  height: calc(100% - 5.6rem);
  overflow: auto;
  .tab-org {
    height: 100%;
    //padding: 0 0.6rem;
  }
  .btns-bottom {
    position: fixed;
    bottom: 0;
    height: 4rem;
    background-color: white;
    left: 0;
    right: 0;
    line-height: 4rem;
    text-align: right;
    border-top: 1px solid #ccc;
    .btn-del {
      border-color: rgb(152, 42, 33);
      color: rgb(152, 42, 33);
      height: 2rem;
      transform: translateY(-10%);
    }
    .div-all {
      display: inline-block;
      margin-left: 20px;
      padding: 0 10px;
      height: 2rem;
    }
  }
}
/deep/ .van-tabs__content {
  height: calc(100% - 45px);
}

/deep/ .van-tabs__line {
  background-color: #c52a1a;
}
/deep/ .van-tabs__wrap {
  padding: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/history/History.vue